import { render, staticRenderFns } from "./Dailyco.vue?vue&type=template&id=c52fcbb6&"
import script from "./Dailyco.vue?vue&type=script&lang=js&"
export * from "./Dailyco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports